import script from "./BookingMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingMenu.vue?vue&type=script&setup=true&lang=ts"

import "./BookingMenu.vue?vue&type=style&index=0&id=17e4a715&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e4a715"]])

export default __exports__